
<div
  :id="content.idHTML"
  :class="[
    jel_getClassObject(content),
    content.isPaddingDynamique === 'true' ? 'padding-dynamique' : 'w-100',
  ]"
>
  <EditableArea
    v-if="content.blocEditable"
    :content="content.blocEditable"
    :parentTemplateId="metadata['mgnl:template']"
  >
  </EditableArea>
</div>
